import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseConversationUnread } from 'entities/Conversation/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type CallHistoryStore } from 'pages/conversations/pages/calls/ui/CallHistory'

export const useEventConversationUnread = (callHistoryStore: CallHistoryStore) => {
  const { websocket } = useEntitiesContext()
  const handler = (data: IResponseConversationUnread) => {
    // Adjust the filter counts locally from the messages that were just read,
    // instead of re-fetching the heavy call-history statistics on every event.
    // The previous `syncFilters()` call on each read fired the expensive
    // statistics query in a tight loop under load (SWR-23600 regression).
    if (data.read_messages.length) {
      callHistoryStore.callHistoryFiltersStore.decreaseCount(data.read_messages)
    }

    if (data.conversation.unread_count === 0) {
      callHistoryStore.markAsReadByConversation(data.conversation_id, data.inbox_id)
      // Debounced + in-flight-guarded reconcile, as a safety net for eventual
      // consistency without stampeding the statistics endpoint.
      callHistoryStore.syncFilters()
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.ConversationUnread, handler), [])
}
